import useUser from 'shared/hooks/use-user'
import { isAdminOrOwnerOfCourse } from '../utils/course-user-role'
import { useCourseData } from './use-course-data'

// TODO: remove
export const useIsUserAdminOrOwnerOfCourse = (): boolean => {
  const { user } = useUser()
  const { courseData } = useCourseData()

  return isAdminOrOwnerOfCourse(user, courseData)
}
